/*eslint-disable*/
import { values } from 'lodash';
import React, { useState, useEffect } from 'react';

const JobcardCheckboxSelect = ({
    field: { name, value },
    form: { touched, errors, setFieldValue },
    ...props
}) => {
    useEffect(() => {
    }, [])

    return (
        <input
            type="checkbox"
            className="hidden"
            readonly=""
            onChange={(value, data) => {
                console.log("{{{{{{{{{{{{{{{{{{{{{{")
                console.log(name)
                console.log(value.target.checked)
                setFieldValue(name, value.target.checked)
                if (props?.setFlag)
                    setFieldValue(props.setFlag, 1)
            }
            }
            {...props}
        />
    )
}

export default JobcardCheckboxSelect